import z from 'zod';
import { DateTimeSchema } from '../dates.js';

// Stored embedding subdocument shared by any entity with vector search
export const IEmbeddingData = z.object({
  embedding: z.unknown().describe('BinData float32 vector (BsonBinary)'),
  textHash: z.string().describe('hashObject of the rendered source text — staleness check'),
  model: z.string(),
  version: z.number().describe('Render-template version at generation time'),
  generatedAt: DateTimeSchema,
});
export type IEmbeddingData = z.infer<typeof IEmbeddingData>;
